import React from 'react';

// theme config import
import themeConfig from '@configs/themeConfig';

export const LoaderComponent = () => {
    const hasLogo = themeConfig.app.appLoader !== undefined && themeConfig.app.appLoader !== null && themeConfig.app.appLoader !== '';

    return (
        <div className="loader-component">
            <div id="loader" className="fallback-spinner app-loader" style={{ display: 'none', width: '100vw' }}>
                {hasLogo && (
                    <span className="logo-ring-wrap">
                        <img className="fallback-logo" src={themeConfig.app.appLoader} height="55px" alt="logo" />
                        <span className="logo-ring"></span>
                    </span>
                )}
            </div>
        </div>
    );
};

var pendingRequest = 0;
const showLoader = (loading) => {
    const loader = document.getElementById('loader');
    if (loader) {
        if (loading === true) {
            pendingRequest++;
            loader.classList.add('d-flex');
        } else {
            pendingRequest--;
            if (pendingRequest <= 0) {
                loader.classList.remove('d-flex');
            }
        }
    }
};

export const forceHideLoader = () => {
    const loader = document.getElementById('loader');
    if (loader) {
        pendingRequest = 0;
        loader.classList.remove('d-flex');
    }
};

export default showLoader;
